import moment from 'moment';
import { browserHistory } from 'react-router';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import { isRequired, minLength } from '../../../core/validations';
import NotificationService from '../../../core/services/NotificationService';

class BannerFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    this.form.validations = {
      name: [isRequired],
      position: [isRequired],
      status: [isRequired],
      segments: [isRequired, minLength(1)],
      initialDate: [isRequired],
      finalDate: [isRequired],
      webImage: [isRequired],
      mobileImage: [isRequired],
    };
  }

  verifyValidations = () => {
    if (this.bannerId) {
      this.form.validations.webImage = [];
      this.form.validations.mobileImage = [];
    } else {
      this.form.validations.webImage = [isRequired];
      this.form.validations.mobileImage = [isRequired];
    }
  };

  init = () => {
    this.form.setInitialValues({
      bannerId: '',
      name: '',
      link: '',
      position: '',
      status: '',
    });
    this.form.reset();
    this.verifyValidations();
  };

  handleChange = (path, value) => {
    this.form.setValue(path, value);
  };

  handleSubmit = () => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const formValues = this.form.getValues();
    const formData = new FormData();
    formData.append('name', formValues.name);
    formData.append('position', formValues.position);
    if (formValues.link) {
      formData.append('link', formValues.link);
    }
    if (formValues.targetAudience) {
      formData.append('targetAudience', formValues.targetAudience);
    }
    if (formValues.stage) {
      formData.append('stage', formValues.stage);
    }
    formData.append('initialDate', moment(formValues.initialDate).utc().startOf('day').toISOString());
    formData.append('finalDate', moment(formValues.finalDate).utc().endOf('day').toISOString());
    formData.append('status', formValues.status);
    formValues.segments.forEach((segment, index) => {
      formData.append(`segments[${index}]`, segment);
    });
    if (formValues.webImage && typeof formValues.webImage !== 'string') {
      formData.append('webImage', formValues.webImage);
    }
    if (formValues.mobileImage && typeof formValues.mobileImage !== 'string') {
      formData.append('mobileImage', formValues.mobileImage);
    }

    if (formValues.id) {
      this.submit
        .fetch({
          method: 'put',
          url: `/banners/${this.bannerId}`,
          apiVersion: 'v2',
          body: formData,
        })
        .then(() => {
          if (this.submit.data) {
            NotificationService.addNotification('Banner successfully updated.', 'success');
            browserHistory.push('/banners');
          }
          if (this.submit.error) {
            NotificationService.addNotification('Error updating Banner', 'error');
          }
        });
    } else {
      this.submit
        .fetch({
          method: 'post',
          url: '/banners',
          apiVersion: 'v2',
          body: formData,
        })
        .then(() => {
          if (this.submit.data) {
            NotificationService.addNotification('Banner successfully created.', 'success');
            browserHistory.push('/banners');
          }
          if (this.submit.error) {
            NotificationService.addNotification('Error creating Banner', 'error');
          }
        });
    }
  };

  handleReset = () => {
    this.form.reset();
  };

  load = (bannerId) => {
    this.bannerId = bannerId;
    this.fetch
      .fetch({
        url: `/banners/${this.bannerId}`,
        apiVersion: 'v2',
      })
      .then(() => {
        if (this.fetch.data) {
          this.form.setValues({
            ...this.fetch.data,
            initialDate: moment(this.fetch.data.initialDate).utc().format(),
            finalDate: moment(this.fetch.data.finalDate).utc().format(),
            bannerName: this.fetch.data.name,
            webImage: this.fetch.data.webImageUrl,
            mobileImage: this.fetch.data.mobileImageUrl,
          });
        }
      });
  };
}

const bannerFormService = new BannerFormService();

export default bannerFormService;
